/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";
import axios from "axios";
import { usePaymentStore } from "./usePaymentStore";
export const useDistributionStore = defineStore("distributionStore", {
  state: () => ({
    distributionsList: {},
    distributionDetail: {
      data: {},
      expensesUnassigned: '',
      servicesUnassigned: ''
    },
    alerts: {},
    saving: false,
    distributionParms: {},
    showAllDistributionParms: {},
    allDistributionsList: {}
  }),
  getters: {
    distributionsTotalPages: state => Math.ceil(state.distributionsList.pagination?.total / state.distributionsList.perPage),
    getNonDistributedDistribution: state => state.allDistributionsList.filter(distribution => distribution.status !== "Distributed")
  },
  actions: {
    async listPaymentDistributions() {
      if (this.distributionParms.statusId === 'all') {
        this.distributionParms.status = '';
      } else {
        this.distributionParms.status = this.distributionParms.statusId;
      }
      try {
        const response = await axios({
          url: "/distributions",
          params: this.distributionParms
        });
        this.distributionsList.pagination = response.data.pagination;
        this.distributionsList.distributions = response.data.distributions?.map(distribution => ({
          value: distribution.id,
          ...distribution
        }));
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    reloadDistributionParms() {
      this.distributionParms = {
        statusId: 'all',
        search: '',
        totals: 'include',
        limit: 20,
        offset: 0,
        orderby: "name",
        order: "desc"
      };
      this.distributionsList = {
        distributions: [],
        pagination: {},
        perPage: 20,
        currentPage: 1
      };
      this.showAllDistributionParms = {
        statusId: 'all',
        offset: 0,
        orderby: "name",
        order: "desc"
      };
    },
    async listAllDistributions() {
      try {
        const response = await axios({
          url: "/distributions",
          params: this.showAllDistributionParms
        });
        this.$patch({
          allDistributionsList: response.data.distributions?.map(distribution => ({
            value: distribution.id,
            ...distribution
          }))
        });
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    async searchDistribution(search) {
      this.distributionParms.search = search;
      let timeout = null;
      clearTimeout(timeout);
      timeout = setTimeout(async () => {
        this.listPaymentDistributions();
      }, 500);
    },
    changeDistributionStatus(distributionsStatus) {
      this.distributionParms.statusId = distributionsStatus;
      this.showDistributionStatusModal = false;
      this.listPaymentDistributions();
    },
    sort(s) {
      if (s === this.distributionParms.orderby) {
        this.distributionParms.order = this.distributionParms.order === "asc" ? "desc" : "asc";
      }
      this.distributionParms.orderby = s;
      this.listPaymentDistributions();
    },
    onPageChange(page, perPage) {
      this.distributionParms.limit = perPage;
      this.distributionsList.currentPage = page;
      this.distributionParms.offset = (this.distributionsList.currentPage - 1) * perPage;
      this.distributionsList.perPage = perPage;
      this.listPaymentDistributions();
    },
    async listDistributionDetail({
      distributionId
    }) {
      const query = {
        data: "payments",
        distributionId,
        status: "all"
      };
      try {
        const response = await axios({
          url: "/reports/accounts",
          params: query
        });
        this.distributionDetail = response.data;
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    async processDistribution({
      param,
      distributionId
    }) {
      try {
        this.saving = true;
        await axios({
          url: `/distributions/${param}/process`,
          method: "POST",
          data: distributionId
        });
        this.alerts.success('Payment processed successfully');
        this.saving = false;
      } catch (error) {
        this.alerts.error(error.response.data.message);
        this.saving = false;
      }
    },
    async updateDistirbutionStatus(body) {
      try {
        this.saving = true;
        await axios({
          url: `/distributions/${body.id}`,
          method: "PUT",
          data: body
        });
        this.alerts.success('Distribution Status Updated successfully');
        this.saving = false;
      } catch (error) {
        this.alerts.error(error.response.data.message);
        this.saving = false;
      }
    },
    async distributionPayments(body, method = "PUT") {
      try {
        await axios({
          url: `/distributionPayments`,
          method,
          data: {
            distributionPayments: body
          }
        });
        const paymentStore = usePaymentStore();
        paymentStore.listPayments();
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    async deleteDistributionPayments(paymentIds) {
      try {
        await axios({
          url: `/distributionPayments/delete`,
          method: "PUT",
          data: {
            paymentIds
          }
        });
        this.alerts.success('Distribution removed from payment successfully');
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    }
  }
});